import React from 'react';
import { STORAGE_URL, MODO_IMPRESSAO, TIPO_DOCUMENTO } from '~/constants';
import { formatDate } from '../../../../../utils/format';

const UserInfoSection = ({ user, empresa, documento, title, tipoDocumento, modoImpressao }) => {
  const urlLogo = `${STORAGE_URL}logo/${empresa?.imagemLogo}`;
  const impressaoA4 = modoImpressao === MODO_IMPRESSAO.A4;

  if (!impressaoA4) {
    const cidade = typeof empresa?.enderecoIntCidade === 'object' ? empresa?.enderecoIntCidade?.cidade : empresa?.enderecoIntCidade;
    const endereco = `${empresa?.enderecoLogradouro ?? ''}, ${empresa?.enderecoLogradouroNumero ?? ''}${empresa?.enderecoBairro ? `, ${empresa.enderecoBairro}` : ''}${cidade ? `-${cidade}` : ''}${empresa?.uf ? `/${empresa.uf}` : ''}`;
    const pequeno = 'var(--small-text-size)';
    const coluna = { display: 'flex', flexDirection: 'column', gap: 'var(--vertical-item-grid-spacing)', fontSize: pequeno, textAlign: 'left' };
    return (
      <div className='scrollable' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 'calc(var(--horizontal-item-grid-spacing)*2)', overflowX: 'auto', padding: 'var(--half-spacing-size) var(--spacing-size)', border: '1px solid black', borderBottom: '1px solid rgba(128, 128, 128, 0.35)' }}>
        <div style={coluna}>
          <strong>{title?.toUpperCase()} - {documento?.serie || documento?.documentoSerie}/{documento?.numero || documento?.documentoNumero}</strong>
          {tipoDocumento === TIPO_DOCUMENTO.DOCUMENTOSAIDA && <span>DOCUMENTO NÃO FISCAL</span>}
        </div>
        <div style={coluna}>
          <span><strong>EMISSÃO:</strong> {documento?.logCriacao ? formatDate(documento.logCriacao) : '---'}</span>
          <span><strong>VENDEDOR:</strong> {documento?.fatVendedor?.nome || '---'}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--half-spacing-size)' }}>
          <img style={{ height: 'var(--url-logo-size)', maxWidth: 'calc(var(--url-logo-size) * 2)', objectFit: 'contain' }} src={urlLogo} alt="logo" />
          <div style={{ ...coluna, fontSize: 'var(--small-text-size)', gap: 1 }}>
            <span>{empresa?.razaoSocial}</span>
            <span>{endereco}</span>
            {empresa?.enderecoCep && <span>CEP: {empresa.enderecoCep}</span>}
          </div>
        </div>
      </div>
    );
  }

  return (
      <div className={`scrollable`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 'calc(var(--horizontal-item-grid-spacing)*2)', overflowX: 'auto', padding: 'var(--spacing-size)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 'var(--half-spacing-size)' }}>
          <div style={{ width: 'var(--url-logo-size)', height: 'var(--url-logo-size)' }}>
            {urlLogo && <img style={{ width: 'var(--url-logo-size)', height: 'var(--url-logo-size)' }} src={urlLogo} alt="logo" />}
          </div>
          <div style={{ gap: 'var(--vertical-item-grid-spacing)', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
            <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
              {empresa.razaoSocial}
            </span>
            <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
              {empresa.enderecoLogradouro}, {empresa.enderecoLogradouroNumero}, {empresa.enderecoIntCidade} / {empresa.uf}
            </span>
            <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
              {empresa.cnpj}
            </span>
          </div>
        </div>
        <div style={{ fontSize: 'var(--regular-text-size)', borderTop: 'none', display: 'grid', gridTemplateColumns: 'auto auto', rowGap: 'var(--vertical-item-grid-spacing)', columnGap: 'calc(var(--horizontal-item-grid-spacing)*2)' }}>
          <strong style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
            Usuário:
          </strong>
          <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
            {user.nome}
          </span>
          <strong style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
            Data/Hora:
          </strong>
          <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left' }}>
            {new Date().toLocaleString('pt-BR')}
          </span>
        </div>
      </div>
  );
};

export default UserInfoSection;
